import { render } from "./Settings.vue?vue&type=template&id=ee66abb6&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"

import "./Settings.vue?vue&type=style&index=0&id=ee66abb6&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee66abb6"],['__file',"src/components/commercialSettings/Settings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ee66abb6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ee66abb6', __exports__)) {
    console.log('reload')
    api.reload('ee66abb6', __exports__)
  }
  
  module.hot.accept("./Settings.vue?vue&type=template&id=ee66abb6&scoped=true", () => {
    console.log('re-render')
    api.rerender('ee66abb6', render)
  })

}


export default __exports__